import fetch from 'isomorphic-fetch'

function instantiateRefreshSession(apiUrl) {
	return function refreshSession(dispatch) {
		const options = {
			method: 'POST',
			credentials: 'include'
		}
		return new Promise(async (resolve, reject) => {
			const refresh = await fetch(`${ apiUrl }/api/accounts/refresh`, options)
				.then(r => {
					if (r.status === 200) {
						return r.json()
					}
					reject('Failed to refresh session!')
				})
			dispatch({
				type: 'USER_UPDATE',
				session: (refresh || {}).account ? JSON.parse(refresh.account) : {}
			})
			resolve(true)
		})
	}
}

export const fetchAction = (url, types, options) => async dispatch => {
	const [REQUEST, SUCCESS, FAILURE] = types
	const { fetchUrl, authorization, apiUrl } = options
	const refreshSession = instantiateRefreshSession(apiUrl)
	try {
		dispatch({
			type: REQUEST,
			query: fetchUrl
		})

		const obj = {
			credentials: 'include'
		}

		if (authorization) {
			obj['headers'] = { authorization }
		}

		const fetchResponse = await fetch(url, obj)
		if (fetchResponse.status === 401) {
			await refreshSession(dispatch)
			return dispatch(fetchAction(url, types, options))
		}
		const responseToJson = await fetchResponse.json()
		return dispatch({
			type: SUCCESS,
			query: fetchUrl,
			response: responseToJson
		})
	} catch (error) {
		return dispatch({
			type: FAILURE,
			query: fetchUrl,
			error: error.message
		})
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/fetchAction.js